import React from 'react';
import { useTranslation } from 'react-i18next';

const ICONS = [
  // Cursor / design
  <svg key="1" width="22" height="22" fill="none" viewBox="0 0 22 22">
    <path d="M4 4l14 6-7 2-2 7L4 4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>,
  // Cube / 3D
  <svg key="2" width="22" height="22" fill="none" viewBox="0 0 22 22">
    <path d="M11 3l8 4v8l-8 4-8-4V7l8-4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M3 7l8 4 8-4M11 11v8" stroke="currentColor" strokeWidth="1.5" />
  </svg>,
  // Inbox / request
  <svg key="3" width="22" height="22" fill="none" viewBox="0 0 22 22">
    <rect x="3" y="3" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M3 13h4l2 3h4l2-3h4" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>,
];

const HowItWorksSection = () => {
  const { t } = useTranslation();
  const steps = t('howItWorks.steps', { returnObjects: true });

  return (
    <section id="how-it-works" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-emerald-500 text-xs font-bold tracking-widest uppercase mb-3">
            {t('howItWorks.label')}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            {t('howItWorks.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-xl mx-auto">
            {t('howItWorks.subtitle')}
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">

          {/* Connector lines (desktop) */}
          <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-px
                          bg-gradient-to-r from-transparent via-gray-700 to-transparent pointer-events-none" />

          {steps.map((step, i) => (
            <div key={i} className="relative flex flex-col items-center text-center gap-5 px-4">

              {/* Number + icon */}
              <div className="relative">
                {/* Step number badge */}
                <span className="absolute -top-2 -right-2 w-5 h-5 bg-emerald-600 text-white
                                 text-xs font-bold rounded-full flex items-center justify-center z-10">
                  {i + 1}
                </span>
                {/* Icon circle */}
                <div className="w-16 h-16 rounded-2xl bg-gray-800 border border-gray-700
                                flex items-center justify-center text-emerald-400">
                  {ICONS[i]}
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <h3 className="text-lg font-bold text-white">{step.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
